import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=b4614f1e&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=b4614f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4614f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4614f1e')) {
      api.createRecord('b4614f1e', component.options)
    } else {
      api.reload('b4614f1e', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=b4614f1e&scoped=true&", function () {
      api.rerender('b4614f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-223kgbEKd2Zfa/JS/comp/SearchFilterTokens.vue"
export default component.exports